module.exports = __webpack_public_path__ + "static/assets/9f071b7b37de58c64697dda0e61536ed.svg";